module.exports = require("@swa-ui/core/src/Multiselect/Multiselect.module.scss");